const priceContracts: {cakeAddress: string, wbchAddress: string, lpAddress:string} = {
  cakeAddress: '0x77beB0D017C743eCa0d22951A3b051A17D50f108',
  wbchAddress: '0x17F4FCF5b6E0A95D4eE331c8529041896A073F9b',
  lpAddress: '0x842692f8A4D0743e942dF5D52155a037327d4f3f'
}

export default priceContracts